require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-nate-birkholz.json") })
        }
      }, "path---blog-author-nate-birkholz");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-nate-birkholz!./.cache/json/blog-author-nate-birkholz.json
// module id = 689
// module chunks = 231608221292675